module.exports = __webpack_public_path__ + "static/img/btn_esc.194a1050.png";